module.exports = __webpack_public_path__ + "img/yj4.119f4c4b.png";